export default "__VITE_ASSET__B96cCg5W__"